/* eslint-disable prettier/prettier */
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { AwsRegions } from '../aws';
import { IsoCountryCode2Char } from '../country-code';

export const AWS_REGION_MARKETS = {
  [AwsRegions.APSE1]: [
    IsoCountryCode2Char.ID,
    IsoCountryCode2Char.JP,
    IsoCountryCode2Char.KR,
    IsoCountryCode2Char.MY,
    IsoCountryCode2Char.NZ,
    IsoCountryCode2Char.SG,
    IsoCountryCode2Char.TH,
    IsoCountryCode2Char.TW,
  ],
  [AwsRegions.EUC1]: [
    IsoCountryCode2Char.AQ,
    IsoCountryCode2Char.AT,
    IsoCountryCode2Char.CH,
    IsoCountryCode2Char.CZ,
    IsoCountryCode2Char.DE,
    IsoCountryCode2Char.ES,
    IsoCountryCode2Char.FR,
    IsoCountryCode2Char.NL,
    IsoCountryCode2Char.PL,
    IsoCountryCode2Char.PT,
    IsoCountryCode2Char.RO,
  ],
  [AwsRegions.USE1]: [
    IsoCountryCode2Char.AQ,
    IsoCountryCode2Char.CA,
    IsoCountryCode2Char.CH,
    IsoCountryCode2Char.GB,
    IsoCountryCode2Char.US,
    IsoCountryCode2Char.ZA,
  ],
};
